export default __webpack_public_path__ + "static/media/rio-demo-thumb.33e806fb.png";